@if (!isLoading) {
<form id="backlogForm" [formGroup]="backlogForm" (ngSubmit)="save(backlogForm)" class="backlog-container">
  <span style="min-width: 150px; max-width: 150px; margin: auto, 0, auto, 0;">{{backlog.name}}: </span>
  <span>
    <input pInputText name="start" type="number" min="0" formControlName="start"
      pKeyFilter="pint" /> to
    <input pInputText name="end" #end type="number" formControlName="end" min="0" pKeyFilter="pint"
      /> Weeks Out
  </span>
  <span>
    <p-button type="submit" [disabled]="!backlogForm.valid" label="Save" />
  </span>
  <br />
  @if (start.invalid && (start.dirty || start.touched)) {
  <span>
    @if (start.errors.required) {
    <span>
      <p-message severity="error" [text]="'A starting value is required'" class="backlog-message"></p-message>
    </span>
    }
  </span>
  }
  @if (endC.invalid && (endC.dirty || endC.touched)) {
  <span>
    @if (endC.errors.required) {
    <span>
      <p-message severity="error" [text]="'An ending value is required'" class="backlog-message"></p-message>
    </span>
    }
    @if (endC.errors.range && (endC.dirty || endC.touched)) {
    <span>
      <p-message severity="error" [text]="'The ending value must be equal to or greater than the starting value.'"
        class="backlog-message"></p-message>
    </span>
    }
  </span>
  }
</form>
}
<div>
  @if (isLoading) {
  <span style="margin-left:8px">
    <i class="pi pi-spin pi-spinner" style="font-size: 3.5em"></i>
  </span>
  }
</div>
<hr />